import { ChevronDown, CloudOff, Command, Download, Menu, Play, Redo2, Save, Undo2 } from 'lucide-react';
import { useState } from 'react';
import { createProjectPackage, downloadBlob } from '../../services/projectPackage';
import { saveProject } from '../../services/persistence';
import { useEditorStore } from '../../store/editorStore';
import { IconButton } from '../ui/IconButton';

export function TopBar() {
  const [fileMenu, setFileMenu] = useState(false);
  const project = useEditorStore((state) => state.project);
  const setModal = useEditorStore((state) => state.setModal);
  const undo = useEditorStore((state) => state.undo);
  const redo = useEditorStore((state) => state.redo);
  const canUndo = useEditorStore((state) => state.past.length > 0);
  const canRedo = useEditorStore((state) => state.future.length > 0);
  const showToast = useEditorStore((state) => state.showToast);

  const save = async () => {
    await saveProject(project, true);
    showToast('Project saved locally', 'success');
  };
  const exportPackage = async () => {
    showToast('Packaging project…');
    const blob = await createProjectPackage(project, true);
    downloadBlob(blob, `${project.name.replace(/[^\w.-]+/g, '-')}.om`);
    showToast('Project package ready', 'success');
  };

  return (
    <header className="topbar">
      <div className="brand-block">
        <button className="app-menu" onClick={() => setFileMenu(!fileMenu)} aria-label="File menu"><Menu size={17} /></button>
        <div className="brand-mark"><Play size={12} fill="currentColor" /></div>
        <div className="brand-name"><b>OPEN MOTION</b><span>STUDIO</span></div>
        {fileMenu && <div className="dropdown file-menu">
          <button onClick={() => { setModal('new-project'); setFileMenu(false); }}>New project <kbd>⌘N</kbd></button>
          <button onClick={() => { setModal('projects'); setFileMenu(false); }}>Open project <kbd>⌘O</kbd></button>
          <button onClick={() => { void save(); setFileMenu(false); }}>Save snapshot <kbd>⌘S</kbd></button>
          <div className="menu-separator" />
          <button onClick={() => { setModal('captions'); setFileMenu(false); }}>Import captions…</button>
          <button onClick={() => { void exportPackage(); setFileMenu(false); }}>Export .om package…</button>
          <button onClick={() => { setModal('export'); setFileMenu(false); }}>Export video… <kbd>⌘E</kbd></button>
        </div>}
      </div>
      <button className="project-switcher" onClick={() => setModal('projects')}>
        <span className="project-dot" /><span>{project.name}</span><ChevronDown size={13} />
      </button>
      <div className="top-center-tools">
        <IconButton icon={<Undo2 size={16} />} label="Undo" onClick={undo} disabled={!canUndo} compact />
        <IconButton icon={<Redo2 size={16} />} label="Redo" onClick={redo} disabled={!canRedo} compact />
      </div>
      <div className="top-actions">
        <span className="local-status" title="Projects and media are stored on this device"><CloudOff size={13} /> Local only</span>
        <IconButton icon={<Save size={15} />} label="Save project" onClick={() => void save()} compact />
        <button className="command-trigger" onClick={() => setModal('command')}><Command size={14} /><span>Quick actions</span><kbd>⌘K</kbd></button>
        <button className="export-button" onClick={() => setModal('export')}><Download size={15} /> Export</button>
      </div>
    </header>
  );
}
